import LayerHash from "../../api/model/snapshots/layers/LayerHash";

function equals(layerHash: LayerHash, otherLayerHash: LayerHash) {
    return (
        layerHash.hash === otherLayerHash.hash &&
        layerHash.type === otherLayerHash.type
    );
}

export { equals };
